import React from 'react'

const Footer = () => {
    return (
        <div>
            <h6 className="text-center mt-5">Developed and Managed by <a href="" style={{color:"teal"}}>ApexvisonDevelpers</a> </h6>
        </div>
    )
}

export default Footer
